<template lang="html">
  <NewCoach working-type="new" />
</template>

<script>
import NewCoach from "./form";

export default {
  components: {
    NewCoach
  }
};
</script>

<style lang="sass" scoped></style>
